export default __webpack_public_path__ + "static/media/darkThemeIcon.f0d8c3e3.svg";